import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import DefaultReviewRenderer from '../DefaultReviewRenderer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function BaseReviewModal({
  review,
  ReviewRenderer = DefaultReviewRenderer,
  title,
  form,
  onConfirm,
  onClose,
  confirmButtonText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-ui-reviews.modal.confirm"
  }),
  confirmButtonDataId,
  cancelButtonText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-ui-reviews.modal.cancel"
  }),
  cancelButtonDataId,
  confirmDisabled = false,
  tooltip,
  width = 800,
  catalogServices
}) {
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "base-review-modal",
    width: width,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: title
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [form, /*#__PURE__*/_jsx(ReviewRenderer, {
        catalogServices: catalogServices,
        review: review
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Tooltip, {
        disabled: !confirmDisabled || !tooltip,
        title: tooltip,
        children: /*#__PURE__*/_jsx(Button, {
          "data-test-id": confirmButtonDataId,
          use: "primary",
          disabled: confirmDisabled,
          onClick: onConfirm,
          children: confirmButtonText
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": cancelButtonDataId,
        use: "secondary",
        onClick: onClose,
        children: cancelButtonText
      })]
    })]
  });
}